import classNames from 'classnames';
import { useMemo } from 'react';

const useProjectProgress = project => {
  const progress = useMemo(() => {
    if (!project.progressTokens) {
      return (project.min / project.max) * 100;
    }
    return Math.ceil(
      (project.progressTokens.min / project.progressTokens.max) * 100
    );
  }, [project]);

  const variant = useMemo(() => {
    return classNames({
      [project.status.type]: project.status.type !== 'secondary',
      700: project.status.type === 'secondary'
    });
  }, [project]);

  const bgClassName = useMemo(() => {
    return classNames({
      [`bg-${project.status.type}-100`]: project.status.type !== 'secondary',
      'bg-200': project.status.type === 'secondary'
    });
  }, [project]);

  return { progress, variant, bgClassName };
};

export default useProjectProgress;
